var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.config).length !== 0)?_c('div',[_c('maz-client-login-header',{attrs:{"config":_vm.config}}),_c('maz-client-login-body',{attrs:{"config":_vm.config}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }